import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./SelectedServicesSection.module.scss";
import arrow_right from "../../../../assets/images/pages/home/selected-services-section/ArrowRight.svg";
import Button from "../../../shared/Button/MainButton";
import { Link, useNavigate } from "react-router-dom";
import HomeServices from "../../../../pages/home/homeService/HomeService";
import icon from "../../../../assets/images/pages/home/selected-services-section/stack.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { Autoplay } from "swiper/modules";

const SelectedServicesSection = () => {
  const [servicesData, setServicesData] = useState<any[]>([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const selectedLanguage = useSelector(
    (state: RootState) => state.language.selectedLanguage?.code
  );
  const swiperRef = useRef<any>(null);
  const navigate = useNavigate();

  const handleNavigateToServices = (groupId: number) => {
    if (groupId === 25) {
      navigate("/repair");
    } else if (groupId === 26) {
      navigate("/install");
    }
  };

  const goToNextSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const backToPrevSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await HomeServices.selectedServices();
        setServicesData(res.data);
      } catch (error) {
        console.log(error, " data error");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedLanguage]);

  useEffect(() => {
    // Dark mode-u yoxla
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains("dark"));
    };

    checkDarkMode();

    // Dark mode dəyişəndə yenilə
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  const translations = useSelector(
    (state: RootState) => state.translations.data
  );

  return (
    <section id={styles.selected_services_section}>
      <div className="container">
        <div className={styles.selected_services_section}>
          <div className={styles.section_head}>
            <h1 className={styles.title}>{translations.selected_services}</h1>
            <div className={styles.next_prev_buttons}>
              <div onClick={backToPrevSlide} className={styles.prev_btn}>
                <img src={arrow_right} alt="" width="40" height="40" />
              </div>
              <div onClick={goToNextSlide} className={styles.next_btn}>
                <img src={arrow_right} alt="" width="40" height="40" />
              </div>
            </div>
          </div>
          <p className={styles.subtitle}>
            {translations.selected_services_description}
          </p>
          <div className={styles.selected_services_slider}>
            <div className={styles.slider}>
              <Swiper
                ref={swiperRef}
                loop={!loading}
                slidesPerView={3}
                spaceBetween={24}
                modules={[Autoplay]}
                onSlideChange={(swiper: any) =>
                  setActiveIndex(swiper.realIndex)
                }
                className={styles.mySwiper}
                allowTouchMove={!loading}
                // autoplay={{
                //   delay: 2000,
                //   disableOnInteraction: false,
                // }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  480: {
                    slidesPerView: 1.3,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 2,
                  },
                  1100: {
                    slidesPerView: 2,
                  },
                  1280: {
                    slidesPerView: 3,
                  },
                }}
              >
                {loading ? (
                  [1, 2, 3].map((idx) => (
                    <SwiperSlide className={`${styles.slide}`} key={`skeleton-${idx}`}>
                      <div className={styles.skeletonCard}>
                        <div>
                          <div className={styles.skeletonCardHead}>
                            <div className={styles.skeletonTitle}></div>
                            <div className={styles.skeletonIcon}></div>
                          </div>
                          <div className={styles.skeletonText}></div>
                          <div className={styles.skeletonText}></div>
                        </div>
                        <div className={styles.skeletonSlideChange}>
                          <div className={styles.skeletonButton}></div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))
                ) : (
                  servicesData.map((slide: any, idx: number) => (
                    <SwiperSlide className={`${styles.slide}`} key={slide.id || idx}>
                      <div
                        className={`${styles.slide_card} ${isDarkMode
                          ? activeIndex === idx
                            ? styles.active_dark
                            : styles.inactive_dark
                          : ""
                          }`}
                        data-index={idx}
                        style={{ background: slide.bg_color_code }}
                        onClick={() =>
                          handleNavigateToServices(slide.service_group_id)
                        }
                      >
                        <div>
                          <div className={styles.card_head}>
                            <h3 className={styles.card_title}>{slide.name}</h3>
                            <img src={icon} alt="icon" width="40" height="40" />
                          </div>
                          <p className={styles.card_text}>
                            {slide.description.length > 200
                              ? slide.description.substring(0, 200)
                              : slide.description}
                            {slide.description.length > 200 && (
                              <span className={styles.more_btn}> ...</span>
                            )}
                          </p>
                        </div>
                        <div className={styles.slide_change}>
                          <div
                            onClick={() =>
                              handleNavigateToServices(slide.service_group_id)
                            }
                            className={styles.change_btn}
                          >
                            <img src={arrow_right} alt="" width="24" height="24" />
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))
                )}
              </Swiper>
            </div>
          </div>

          <div className={styles.services_container}>
            {loading ? (
              [1, 2, 3, 4].map((idx) => (
                <div key={idx} className={styles.skeletonServiceItem}>
                  <div className={styles.skeletonCardHead}>
                    <div className={styles.skeletonTitle}></div>
                    <div className={styles.skeletonIcon}></div>
                  </div>
                  <div className={styles.skeletonContentText}></div>
                  <div className={styles.skeletonContentText}></div>
                  <div className={styles.skeletonSlideChange}>
                    <div className={styles.skeletonButton}></div>
                  </div>
                </div>
              ))
            ) : (
              servicesData.map((slide: any, idx: number) => {
                return (
                  <div
                    key={idx}
                    className={styles.service_item}
                    style={{ background: slide.bg_color_code }}
                    onClick={() =>
                      handleNavigateToServices(slide.service_group_id)
                    }
                  >
                    <div className={styles.card_head}>
                      <h3 className={styles.card_title}>{slide.name}</h3>
                      <div className={styles.card_icon_container}>
                        <img className={styles.card_icon} src={icon} alt="arrow_left_icon" width="40" height="40" />
                      </div>
                    </div>
                    <p className={styles.content_text}>{slide.description}</p>
                    <div className={styles.slide_change}>
                      <div
                        onClick={() =>
                          handleNavigateToServices(slide.service_group_id)
                        }
                        className={styles.change_btn}
                      >
                        <img src={arrow_right} alt="arrow_right_icon" width="24" height="24" />
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
          <div className={styles.apply_button}>
            <Link to={"applyService"}>
              <Button
                className={`${styles.apply_btn} ${isDarkMode ? styles.apply_btn_dark : ""
                  }`}
                text={translations.apply}
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SelectedServicesSection;
